import { defineMessages } from 'react-intl';

export const pixelEntryMessages: {
	validationFailedMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputWidthTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputWidthAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputWidthLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputHeightTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputHeightAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	submitButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullWidthLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	migrationButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	migrationButtonTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closePixelEntry: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resizeOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	validationFailedMessage: {
		id: 'fabric.editor.media.pixelEntry.validationFailedMessage',
		defaultMessage: 'Validation for width failed',
		description: 'The passed in validator function returned false',
	},
	inputWidthTooltip: {
		id: 'fabric.editor.media.pixelEntry.inputWidthTooltip',
		defaultMessage: 'Max width {maxWidth}px',
		description: 'The tooltip displayed ontop of the width input',
	},
	inputWidthAriaLabel: {
		id: 'fabric.editor.media.pixelEntry.inputWidthAriaLabel',
		defaultMessage: 'Max width {maxWidth}px',
		description:
			'Aria label for the width input field used for media pixel entry. The placeholder {maxWidth} will be substituted with the maximum allowed width value in pixels.',
	},
	inputWidthLabel: {
		id: 'fabric.editor.media.pixelEntry.inputWidthLabel',
		defaultMessage: 'Width',
		description:
			'Label for the width input field in the media resize panel. Users enter a numeric value representing the desired width in pixels for the image.',
	},
	inputHeightTooltip: {
		id: 'fabric.editor.media.pixelEntry.inputHeightTooltip',
		defaultMessage: 'Height',
		description: 'The tooltip displayed ontop of the height input',
	},
	inputHeightAriaLabel: {
		id: 'fabric.editor.media.pixelEntry.inputHeightAriaLabel',
		defaultMessage: 'height input',
		description:
			'Aria label for the height input field used for media pixel entry to inform screen readers about the purpose of the input.',
	},
	submitButtonText: {
		id: 'fabric.editor.media.pixelEntry.submitButtonText',
		defaultMessage: 'Submit',
		description: 'The text give to the hidden submit button',
	},
	fullWidthLabel: {
		id: 'fabric.editor.image.fullWidthLabel',
		defaultMessage: 'Full-width',
		description:
			'Label shown in the media pixel entry toolbar when the image is at its maximum width, indicating the image is in full-width display mode.',
	},
	migrationButtonText: {
		id: 'fabric.editor.media.pixelEntry.migrationButtonText',
		defaultMessage: 'Convert to pixels',
		description: 'The text give to the button used to covert to pixels for legacy experience',
	},
	migrationButtonTooltip: {
		id: 'fabric.editor.media.pixelEntry.migrationButtonTooltip',
		defaultMessage: 'Migrate from percentage to fixed pixel sizing',
		description: 'The tooltip displayed on the migration button',
	},
	closePixelEntry: {
		id: 'fabric.editor.media.pixelEntry.closePixelEntry',
		defaultMessage: 'Close',
		description:
			'The text give to the close button used to close the pixel inputs and go back to main toolbar',
	},
	resizeOption: {
		id: 'fabric.editor.media.pixelEntry.ResizeOption',
		defaultMessage: 'Resize',
		description: 'The text give to the resize option in the overflow dropdown for images',
	},
});
